<script lang="ts">
  import Content from './Content.svelte';
  import type { Network, TokenMetadata } from '$lib/interfaces';
  import { NETWORK_TO_ICON } from '$lib/contracts';

  export let metadata: TokenMetadata;
  export let network: Network | undefined = undefined;
  export let autoplay = false;
  export let muted = true;
  export let controls = false;
  export let shadow = false;
  export let square = false;
  export let scale = false;
  export let rounded = false;
  export let className = '';
</script>

{#if square}
  <div class:square>
    <Content
      {metadata}
      {autoplay}
      {muted}
      {controls}
      {shadow}
      {scale}
      {rounded}
      {className}
      square
    />
    {#if network && NETWORK_TO_ICON[network]}
      <i
        class={`absolute bottom-0 left-0 m-3 text-white text-bg-primary icon-outline ${NETWORK_TO_ICON[network]}`}
      />
    {/if}
  </div>
{:else}
  <Content {metadata} {autoplay} {muted} {controls} {shadow} {scale} {rounded} {className} />
  {#if network && NETWORK_TO_ICON[network]}
    <i
      class={`absolute bottom-0 left-0 m-3 text-white text-bg-primary icon-outline ${NETWORK_TO_ICON[network]}`}
    />
  {/if}
{/if}

<style>
  .square {
    width: 100%;
    padding-top: 100%;
    position: relative;
  }
</style>
